import ReactDOM from 'react-dom';
// Defined in general.js
// These dependencies are being included for use in sub-modules.
import '../../handlebars/templates/teacherSuggestion.tmpl.js';
import '../../handlebars/templates/schoolSuggestion.tmpl.js';

import HomeController from './HomeController.js';


// These must be defined in the JSP
/* global linkToProjectCreation showRecentDonationsOnExistingDonorHomepage leadGenEnabled minimizedLeadGenEnabled */
ReactDOM.hydrate(
    <HomeController linkToProjectCreation={linkToProjectCreation}
        alternateHomeSection={window.alternateHomeSection}
        showRecentDonations={showRecentDonationsOnExistingDonorHomepage}
        leadGenEnabled={leadGenEnabled}
        minimizedLeadGenEnabled={minimizedLeadGenEnabled}
    />,
    document.getElementById('content'),
);
